"use client";
import { APP_ROUTES } from "@/constants/routes";
import { User } from "@/models/user";
import { Box } from "@mui/material";
import { useLocale, useTranslations } from "next-intl";
import Link from "next/link";

const TrialConsumer = ({ user }: { user: User }) => {
  const t = useTranslations("messages");
  const locale = useLocale();
  return (
    <Box
      className="gap-[10px] grid"
      sx={{
        paddingBottom: "24px",
        paddingX: { xs: "20px", sm: "0" },
      }}
    >
      <p className="font-semibold text-2xl/6 sm:text-[32px]/[39.01px] text-eerie_black m-0">
        {t("home_welcome")} {user && user?.firstName},
      </p>
      {user?.license && user?.license.isTrial ? (
        <p
          className="font-medium text-base/[19.5px] text-gray_80 m-0"
          translation-key="home_tagline_trial"
        >
          {t("home_tagline_trial")}{" "}
          <Link
            className="font-[Montserrat] text-cimigo-blue font-semibold text-[18px] account-go-to-subscription-link"
            translation-key="home_tagline_trial_link"
            href={`${APP_ROUTES(locale).ACCOUNT.SUBSCRIPTION.to}?open=true`}
          >
            {t("home_tagline_trial_link")}
          </Link>
        </p>
      ) : (
        <p
          className="font-medium text-base/[19.5px] text-gray_80 m-0"
          translation-key="home_tagline"
        >
          {t("home_tagline")}
        </p>
      )}
    </Box>
  );
};

export default TrialConsumer;
